export default __webpack_public_path__ + "static/media/IMG_9946.b99e743f.jpg";